import { background, blue } from "../colors";
import { fontSize, fontWeight, letterSpacing } from "../typography";

export const MuiListItemButton = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: "primary" },
          style: {
            backgroundColor: background.light,
            paddingLeft: 24,

            "& .MuiListItemText-root": {
              textTransform: "uppercase",
              margin: 0,
            },

            "& .MuiListItemText-primary": {
              fontSize: fontSize.small,
              fontWeight: fontWeight.medium,
              letterSpacing: letterSpacing[105],
            },

            "&:hover": {
              backgroundColor: background.light,
            },
          },
        },
        {
          props: { variant: "secondary" },
          style: {
            paddingLeft: 24,
            paddingTop: 16,
            paddingBottom: 16,
            borderTop: `1px solid ${background.light}`,

            "& .MuiListItemText-root": {
              margin: 0,
            },

            "& .MuiListItemText-primary": {
              color: blue[100],
              fontWeight: fontWeight.bold,
            },
          },
        },
      ],
    },
  },
};

export const MuiList = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: "ordered" },
          style: {
            listStyle: "decimal",
            paddingLeft: "16px",
          },
        },
      ],
    },
  },
};
